module.exports = __webpack_public_path__ + "img/如何美化文本.6b1ef4e8.gif";